import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { Philosophy } from './Philosophy';
import { CorePrincipe } from './CorePrincipe';
import { UserCentricity } from './UserCentricity';
import { Contionous } from './Contionous';
import { Trust } from './Trust';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';

const AboutUs = ({t, i18n}) => {
    i18n.loadNamespaces('aboutus');

    const pages = [
        {
            title: 'The core principle',
            component: CorePrincipe,
        },
        {
            title: 'User centricity from the start',
            component: UserCentricity,
        },
        {
            title: 'Continuous growth',
            component: Contionous,
        },
        {
            title: 'Trust is everything',
            component: Trust,
        },
    ];

    return (
        <Page>
            <PageNavigation t={t} onThisPage={pages.map(page => t(`aboutus>${page.title}`))}/>
            <FlexDiv direction="column">
                <Margin><Philosophy t={(text) => t(`aboutus>${text}`)}/></Margin>
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={'50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        t: (text) => t(`aboutus>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const AboutUsContainer = withTrans(AboutUs)